import "tinymce";
import "tinymce/themes/silver";
import "tinymce/models/dom";
import "tinymce/icons/default"
import "tinymce/plugins/table";
import "tinymce/plugins/lists";
import "tinymce/plugins/advlist";

declare const tinymce: any;

import { Component, Input, Output, EventEmitter, OnChanges, OnInit, OnDestroy, NgModule, ViewChild, ElementRef, AfterViewInit, NgZone} from '@angular/core';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { GlobalCfgFactory } from "@shared/factories/global-cfg/global-cfg.factory";
import { ModalServiceService } from "@shared/services/modal-service/modal-service.service";
import { CustomLandingFactory } from "@shared/factories/custom-landing/custom-landing.factory";
import { BroadcastService } from "@shared/services/broadcast/broadcast.service";
import { AfTranslateFactory } from "@shared/modules/translate/factory/translate.factory";
import { ContextFactory } from "@shared/factories/context/context.factory";
import { LoaderFactory } from "@shared/factories/loader/loader.factory";
import { ApiServiceService } from "@shared/services/api-service/api-service.service";
import { EditorComponent } from "@tinymce/tinymce-angular";
import { OverlayPanel, OverlayPanelModule } from "primeng/overlaypanel";
import { AfTranslateDirective } from "@shared/modules/translate/directive/af-translate.directive";
import { SpanTooltipComponent } from "../span-tooltip/span-tooltip.component";
import { FormsModule } from "@angular/forms";
import { NgClass } from "@angular/common";
import { ByWordPipe } from "@shared/filters/by-word/by-word.pipe";
import { AfTranslatePipe } from "@shared/modules/translate/pipe/af-translate.pipe";


@Component({
    selector: 'rich-editor',
    templateUrl: './rich-editor.component.html',
    standalone: true,
    imports: [
      EditorComponent,
      OverlayPanelModule,
      AfTranslateDirective,
      SpanTooltipComponent,
      FormsModule,
      NgClass,
      ByWordPipe,
      AfTranslatePipe
    ]
})
export class RichEditorComponent implements OnInit, OnChanges, OnDestroy {
  subscribers: any = {};
  isLanding: boolean = this.customLanding.isLanding();
  skin: any = this.isLanding?'landing':this.globalCfg.skin;
  elementId:string = this.commonUtilsService.createId();
  // classType: any = '';
  events: any = null;
  // placeholder: any = this.translate.instant('common.write-here');
  blurFunction: any = null;
  customButtons: any = null;
  noEditable: boolean = false;
  toolbar: any = 'undo redo | blocks removeformat | bold italic underline | alignment bullist numlist | link';
  height: any = 164;
  editor:any;
  configuredEditor: boolean = false;
  initEditor: boolean = false;
  richEditor: Object;
  listOverlayConfig: any = {
    buttonContainer: null,
    buttonClass: '',
    filterSearch: false,
    inputFilter: '',
    list: []
  }
  savedBookmark: any;

  constructor(private context: ContextFactory,
    private globalCfg: GlobalCfgFactory,
    private translate: AfTranslateFactory,
    private customLanding: CustomLandingFactory,
    private loader: LoaderFactory,
    private commonUtilsService: CommonUtilsService,
    private modalService: ModalServiceService,
    private broadcastService: BroadcastService,
    private apiService: ApiServiceService,
    private zone: NgZone
  ) { }

  @Input() tinyMceOptions: any = null;
  @Input() field: any = null;
  @Input() modelText: any = '';
  @Output() emitValue = new EventEmitter();
  @ViewChild('listOverlay') listOverlay: OverlayPanel;
  @ViewChild('listOverlayButton') listOverlayButton: ElementRef<HTMLElement>;
  @ViewChild('snippetModalButton') snippetModalButton: ElementRef<HTMLElement>;

  ngOnInit(){
    this.watchChangeEditableFieldRich();
  }

  ngOnChanges(): void {
    if(this.modelText ==='' || this.modelText === undefined || this.modelText === null){
      // this.placeholder = this.tinyMceOptions.placeholder?this.tinyMceOptions.placeholder:'';
      if(this.initEditor){
        this.editor.setContent('');
      }
    }else if(this.initEditor){
      tinymce.get(this.elementId).setContent(this.modelText);
    }
    this.configureTinyOptions();
  }

  configureTinyOptions(){
    if(this.tinyMceOptions && this.tinyMceOptions !== null){
      this.events = this.tinyMceOptions.events;
      // this.placeholder = this.tinyMceOptions.placeholder?this.tinyMceOptions.placeholder:'';
      this.blurFunction = this.tinyMceOptions.blurFunction;
      this.customButtons = this.tinyMceOptions.customButtons;
      this.noEditable = this.tinyMceOptions.noEditable;
      this.height = this.tinyMceOptions.expanded?344:164;
      // this.classType = this.tinyMceOptions.typeView?'rich-editor--'+this.tinyMceOptions.typeView:'';
      this.toolbar = this.tinyMceOptions.toolbar?this.tinyMceOptions.toolbar:this.toolbar;
      if(this.customButtons?.length){
        this.customButtons.forEach((button: any)=> {
          this.toolbar += ' ' + button.type;
        })
      }
      if(!this.configuredEditor){
        this.configuredEditor = true;
        this.initTinyEditor();
      }
    }
  }

  initTinyEditor() {
    this.richEditor = {
      // placeholder: this.placeholder,
      placeholder: this.translate.instant('common.write-here'),
      readonly: this.noEditable,
      base_url: '/tinymce',
      suffix: '.min',
      content_css: [location.origin + '/assets/css/rich-editor.css'],
      body_class: this.configureBodyClass(),
      // body_class: 'rich-editor__body-tinymce rich-editor__body-tinymce--'+ this.skin + (this.tinyMceOptions.sequentialView ? ' rich-editor__body-tinymce--sequential' : '') + (this.noEditable ? ' rich-editor__body-tinymce--disabled' : ''),
      // body_class: this.noEditable ? 'rich-editor__disabled-tinymce-'+ this.skin : 'rich-editor__body-tinymce rich-editor__body-tinymce--'+ this.skin,
      selector: 'textarea#' + this.elementId,
      menubar: false,
      statusbar: false,
      formats: {
        underline: { inline: 'u', styles: { 'text-decoration': 'underline' }, exact: true }
      },
      valid_children: '+body[style], -div[div], -li[div], -ul[div], -ol[div], -td[div], -th[div]',
      tabfocus: ':prev,:next',
      plugins: 'lists advlist',
      paste_as_text: true,
      height: this.height,
      toolbar: this.toolbar,
      mobile: {
        toolbar_mode: 'floating'
      },
      setup: (editor: any) => {
        this.editor = editor;
        if (this.modelText) {
          editor.on('init', () => {
            editor.setContent(this.modelText);
          })
        }
        if (this.tinyMceOptions.withFocus) {
          editor.on('focus', () => {
            $('#container-box-' + this.tinyMceOptions.id).addClass('common-text-input__container-box--focused');
          });
        }

        editor.on('click', () => {
          let showMoreButton = editor.getContainer().querySelector('.tox-tbtn.tox-tbtn--enabled[aria-label="Reveal or hide additional toolbar items"]') as HTMLElement;
          if (showMoreButton) {
            showMoreButton.click();
          }
          this.zone.run(() => {
            if (this.listOverlay) {
              this.listOverlay.hide();
            }
          });
        });

        editor.on('blur', () => {
          this.emitValue.emit({ model: editor.getContent() });
          if (this.tinyMceOptions.withFocus) {
            $('#container-box-' + this.tinyMceOptions.id).removeClass('common-text-input__container-box--focused');
          }
          if (this.blurFunction) {
            this.blurFunction();
          }
        })

        for (let k in this.events) {
          if (this.events.hasOwnProperty(k)) {
            typeof this.events[k] === 'function' ? editor.on(k, this.events[k]) : console.error('Invalid tinyEditor events initialization. Value for ' + k + ' must be a function');
          }
        }

        //Buttons
        this.changeIcons(this.editor);
        this.editor.ui.registry.addGroupToolbarButton('alignment', {
          icon: 'align-left',
          tooltip: 'Alignment',
          items: 'alignleft aligncenter alignright alignjustify'
        });
        this.editor.ui.registry.addButton('link', {
          icon: 'link',
          onAction: (e: any) => {
            let addLink: any = $('#addLink-' + this.elementId);
            addLink.click();
          }
        });
        this.configureCustomButtons(editor);

      }
    }
    this.initEditor = true;
  }

  configureBodyClass(){
    let bodyClass: string = 'rich-editor__body-tinymce rich-editor__body-tinymce--'+ this.skin;
    if(this.isLanding && this.field?.sequentialView){
      bodyClass += ' rich-editor__body-tinymce--sequential';
    }
    if(this.noEditable){
      bodyClass += ' rich-editor__body-tinymce--disabled';
    }
    return bodyClass;
  }

  changeIcons(editor: any){
    editor.ui.registry.addIcon('bold', '<i class="lf-icon-bold-scale100"></i>');
    editor.ui.registry.addIcon('italic', '<i class="lf-icon-italic-scale100"></i>');
    editor.ui.registry.addIcon('underline', '<i class="lf-icon-underline-scale100"></i>');
  }

  addLink(e: any){
    e.stopPropagation();
    let selectedNode: any;
    let oldNodeLink = tinymce.activeEditor.selection.getNode().tagName === 'A'?true:false;
    if(oldNodeLink){
      selectedNode = tinymce.activeEditor.selection.getNode();
      tinymce.activeEditor.selection.select(selectedNode);
    }
    let bookmark: any = tinymce.activeEditor.selection.getBookmark(2);
    let selectedContent: any = tinymce.activeEditor.selection.getContent();
    this.disableActiveButtons();
    this.modalService.linkModal(selectedNode, selectedContent)
      .subscribe((result:any)=>{
        tinymce.activeEditor.selection.moveToBookmark(bookmark);
        if(result.result === 'ok'){
          tinymce.activeEditor.insertContent(result.link);
        }
      })
  }

  configureCustomButtons(editor: any) {
    if (this.customButtons?.length) {
      this.customButtons.forEach((button: any) => {
        switch (button.type) {
          case 'bookmarksTag':
            this.addTinyMceBookmarksCombo(button.list, editor);
            break;
          case 'snippetsTag':
            this.addTinyMceSnippetsCombo(button.list, editor);
            break;
          case 'addNewFragment':
            this.addNewFragmentIcon(editor);
            break;
          default:
            break;
        }
      });
    }
  }

  setUpListCustomButton(iconClass: string, classButton: string) {
    const customListButton = this.editor.getContainer().querySelector(`button.tox-tbtn:has(${iconClass})`) as HTMLElement;
    if (!customListButton) {
      return;
    }
    customListButton.style.width = '48px';
    customListButton.classList.add(classButton);
    if (!customListButton.querySelector('.tox-tbtn__select-chevron')) {
      customListButton.insertAdjacentHTML('beforeend', '<div class="tox-tbtn__select-chevron"><svg width="10" height="10" focusable="false"><path d="M8.7 2.2c.3-.3.8-.3 1 0 .4.4.4.9 0 1.2L5.7 7.8c-.3.3-.9.3-1.2 0L.2 3.4a.8.8 0 0 1 0-1.2c.3-.3.8-.3 1.1 0L5 6l3.7-3.8Z" fill-rule="nonzero"></path></svg></div>');
    }
  }

  addTinyMceBookmarksCombo(bookmarks: any[], editor: any) {
    bookmarks.forEach((bookmark: any) => {
      bookmark.value = bookmark.tag;
    });
    editor.ui.registry.addIcon('bookmarksIcon', '<i class="lf-icon-bookmarks common-icon__md"></i>');
    this.editor.ui.registry.addButton('bookmarksTag', {
      icon: 'bookmarksIcon',
      //tooltip: this.translate.instant('common.insert-bookmarks'),
      onSetup: () => {
        this.setUpListCustomButton('.lf-icon-bookmarks', 'rich-editor__bookmarks-button');
        return () => { };
      },
      onAction: () => {
        this.savedBookmark = this.editor.selection.getBookmark(2, true);
        this.listOverlayConfig.list = this.customButtons.find((button: any) => button.type === 'bookmarksTag').list ?? [];
        this.listOverlayConfig.buttonClass = '.rich-editor__bookmarks-button';
        this.listOverlayButton.nativeElement.click();
      },
    });
  }

  addTinyMceSnippetsCombo(snippets: any[], editor: any) {
    snippets.forEach((snippet: any) => {
      snippet.fieldLabel = snippet.title;
      snippet.value = snippet.text;
    });
    editor.ui.registry.addIcon('snippetsIcon', '<i class="lf-icon-paste-plain-text common-icon__md"></i>');
    this.editor.ui.registry.addButton('snippetsTag', {
      icon: 'snippetsIcon',
      //tooltip: this.translate.instant('common.insert-snippets'),
      onSetup: () => {
        this.setUpListCustomButton('.lf-icon-paste-plain-text', 'rich-editor__snippets-button');
        return () => { };
      },
      onAction: () => {
        this.savedBookmark = this.editor.selection.getBookmark(2, true);
        this.listOverlayConfig.list = this.customButtons.find((button: any) => button.type === 'snippetsTag').list ?? [];
        this.listOverlayConfig.buttonClass = '.rich-editor__snippets-button';
        this.listOverlayButton.nativeElement.click();
      },
    });
  }

  addNewFragmentIcon(editor: any) {
    editor.ui.registry.addIcon('newFragmentIcon', '<i class="lf-icon-add-round common-icon__md"></i>');
    this.editor.ui.registry.addButton('addNewFragment', {
      icon: 'newFragmentIcon',
      tooltip: this.translate.instant('field-items.new-fragment'),
      onSetup: (button: any) => {
        const selectionHandler = () => button.setEnabled(editor.selection.getContent().trim() !== '');
        editor.on('SelectionChange', selectionHandler);
        selectionHandler();
        return () => editor.off('SelectionChange', selectionHandler);
      },
      onAction: (e: any) => {
        this.snippetModalButton.nativeElement.click();
      }
    });
  }

  toggleListOverlay(e: any) {
    this.listOverlayConfig.inputFilter = '';
    this.listOverlayConfig.filterSearch = this.listOverlayConfig.list.length > 5;
    // Check first if it's inside a modal
    let bookmarkButton = document.querySelector(`.tox-tinymce-aux ${this.listOverlayConfig.buttonClass}`) as HTMLElement;
    if (!bookmarkButton) {
      bookmarkButton = this.editor.getContainer().querySelector(this.listOverlayConfig.buttonClass) as HTMLElement;
    }
    this.listOverlay.toggle(e, bookmarkButton);
  }

  onListItemClick(item: any) {
    this.editor.focus();
    if (this.savedBookmark) {
      this.editor.selection.moveToBookmark(this.savedBookmark);
      this.savedBookmark = null;
    }
    this.editor.insertContent(item.value);
    this.listOverlay.hide();
  }

  disableActiveButtons() {
    Array.from(this.editor.getContainer().querySelectorAll('.tox-tbtn.tox-tbtn--enabled'))
      .forEach((activeButton: any) => activeButton.click());
  }

  openSnippetModal() {
    // disable all active buttons
    this.disableActiveButtons();
    const configuration = {
      product: this.context.settings.defaultProduct,
      snippet: {
        shortId: '',
        title: '',
        text: tinymce.activeEditor.selection.getContent()
      },
      type: 'new-fragment'
    }
    this.modalService.newSnippetModal(this.customButtons.find((button: any) => button.type === 'snippetsTag').list ?? [], configuration)
      .subscribe((result: any) => {
        if (result.result === 'ok') {
          this.addSnippet(result.snippet);
        }
      });
  }

  addSnippet(snippet: any) {
    snippet.productId = this.context.settings.defaultProduct;
    this.loader.openLoader('open-create-snippet');
    this.apiService.add('snippets', snippet)
      .then((data: any) => {
        data.fieldLabel = data.title;
        data.value = data.text;
        this.customButtons.find((button: any) => button.type === 'snippetsTag').list.push(data);
        this.loader.closeLoader(['open-create-snippet']);
        this.modalService.successModal({ text: this.translate.instant('snippets-reusable.text-block-saved') });
      }, (errorData: any) => {
        this.loader.closeError();
        this.modalService.errorModal({ text: this.translate.instant('common.unexpected-error') });
      });
  }

  watchChangeEditableFieldRich(){
    this.subscribers.changeEditableFieldRichBroadcast = this.broadcastService.subscribe("changeEditableFieldRich", (data:any) => {
      if(this.tinyMceOptions.id === data.richEditor.richId){
        this.tinyMceOptions.noEditable = data.richEditor.noEditable;
        let editor: any = tinymce.get(this.elementId);
        let readonly = data.richEditor.noEditable?'readonly':'design';
        editor.mode.set(readonly);
        editor.mode.set(readonly);
        if(data.richEditor.noEditable){
          editor.dom.addClass(editor.getBody(), 'rich-editor__disabled-tinymce-'+ this.skin);
          editor.dom.removeClass(editor.getBody(), 'rich-editor__body-tinymce rich-editor__body-tinymce--'+ this.skin);
        }else{
          editor.dom.addClass(editor.getBody(), 'rich-editor__body-tinymce rich-editor__body-tinymce--'+ this.skin);
          editor.dom.removeClass(editor.getBody(), 'rich-editor__disabled-tinymce-'+ this.skin);
        }
      }
    })
  }

  ngOnDestroy(){
    this.commonUtilsService.OnDestroy(this.subscribers);
  }
}
